class Iframe {
  constructor(node, options = {}) {
    this.props = {
      ...options,
    };

    this.node = node;
    this.figure = node.parentNode;
    this.node.decorator = this;
    this.responsify();
  }

  responsify = () => {
    const width = this.node.offsetWidth;
    const height = this.node.offsetHeight;
    if (width && height) {
      this.figure.classList.add('responsive-iframe');
      this.figure.style.paddingTop = `${(height / width) * 100}%`;
    }
  };
}

export default (node, props) => new Iframe(node, props);
